<template></template>
<script>
    import DailyNewsCardsComponent from '../../components/pagesbuilder/dynamic-components/DailyNewsCardsComponent.vue';
    import PreviewComponent from "./PreviewComponent";

    export default {
        name: "PreviewDailyNewsCardsComponent",
        mixins: [PreviewComponent,DailyNewsCardsComponent],
        methods: {
            addListeners() {
                this.componentNode.querySelectorAll('[data-link]').forEach((card) => {
                    card.addEventListener('click', (e) => {
                        if (!e.target.getAttribute("href")) {
                            window.open(card.getAttribute("data-link"));
                        }

                    })
                })
            },
            seeAllClicked () {
                document.location.href = "/dailynews";
            },
            loadMoreClicked () {
                this.setRows({value: this.myData.rows + 1});
            },
            toggleMySectionVisibility (display) {
                const mySection = this.hasContext('section')[0];
                if (mySection) {
                    const mySectionState = this.findNodeState(mySection.id);
                    mySectionState.myNode.style.display = display ? 'block' : null;
                }
            }
        },
        watch: {
            "articles" : {
                deep: true,
                handler (newVal) {
                    const hasArticles = newVal?.length > 0;
                    this.toggleMySectionVisibility(hasArticles);
                }
            },
        },
    }
</script>
